import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import { Box, Typography } from '@material-ui/core';
import OpacityIcon from '@material-ui/icons/Opacity';
import { useTranslation } from 'react-i18next';
import { styles } from './style';
import { makeStyles } from '@material-ui/core/styles';
import RRIMap from './RriMap/RRIMap';
import RRISidebar from './RriMap/RRISidebar/RRISidebar';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import orderBy from 'lodash/orderBy';
import dayjs from 'dayjs';
import RRIRightSidebar from './RriMap/RRISidebar/RRIRightSidebar';


const useStyles = makeStyles(styles);
const initPath = process.env.REACT_APP_THAIWATER_URL;
const initFewsUrl = process.env.REACT_APP_FEWS_URL;
const API = process.env.REACT_APP_API_URL;

export default function Main() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [map, setMap] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mainRiver, setMainRiver] = useState(false);
  const [basin, setBasin] = useState(false);
  const [waterLevel, setWaterLevel] = useState(false);
  const [datas, setDatas] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ header: '', content: null });
  const [forecastDay, setForecastDay] = useState(1);
  const [rainfallEnabled, setRainfallEnabled] = useState(false);
  const [dataRainfall24, setDataRainfall24] = useState([]);
  const [datasRainTodayMarker, setDatasRainTodayMarker] = useState([]);
  const [datasRainYesterday, setDatasRainYesterday] = useState([]);
  const [datasRain3day, setDatasRain3day] = useState([]);
  const [datasRain7day, setDatasRain7day] = useState([]);
  const [datasRain15Day, setDatasRain15Day] = useState([]);
  const [datasLargeDam, setDatasLargeDam] = useState([]);
  const [datasMediumDam, setDatasMediumDam] = useState([]);
  const [largeDamEnabled, setLargeDamEnabled] = useState(false);
  const [mediumDamEnabled, setMediumDamEnabled] = useState(false);
  const [rriStationEnabled, setRriStationEnabled] = useState(true);
  const [rriStations, setRriStations] = useState([]);
  const [rriTifUrl, setRriTifUrl] = useState('');
  const [mapInstance, setMapInstance] = useState(null);
  const [rriReservoirEnabled, setRriReservoirEnabled] = useState(true);
  const [rightSidebarOpen, setRightSidebarOpen] = useState(false);
  const [selectedStation, setSelectedStation] = useState(null);
  const [rriLatestQr, setRriLatestQr] = useState({});
  const [rriTifEnabled, setRriTifEnabled] = useState(true);
  const [rriThresholds, setRriThresholds] = useState({});
  const [statusFilter, setStatusFilter] = useState(0);
  const [datasRain30Day, setDatasRain30Day] = useState([]);
  const [waterlevelMeta, setWaterlevelMeta] = useState({}); // { station_id: { discharge, situation_level, ... } }
  const [damMeta, setDamMeta] = useState({});

  const handleSetMap = (m) => {
    setMap(m);
    setMapInstance(m);
  };

  const forecastDayToType = {
    1: 'rainfallYesterday',
    2: 'rainfallToday',
    3: 'rainfall24h',
    4: 'rainfall3day',
    5: 'rainfall7day',
    6: 'rainfall15day',
    7: 'rainfall30day',
  };

  const handleModalOpen = (params) => {
    setModalContent(params);
    setModalOpen(true);
  };
  const handleModalClose = () => setModalOpen(false);

  const handleMarkerClick = (data) => {
    console.log('marker data:', data);
    setSelectedStation(data);
    setRightSidebarOpen(true);
  };

  useEffect(() => {
    if (!map) return;
    const container = map.getContainer();
    let raf = null;

    const ro = new ResizeObserver(() => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        if (map._container) map.invalidateSize({ animate: false });
      });
    });

    ro.observe(container);
    return () => {
      cancelAnimationFrame(raf);
      ro.disconnect();
    };
  }, [map]);

  useEffect(() => {
    if (!rriStationEnabled && selectedStation?.type === 'station') {
      setRightSidebarOpen(false);
    }
    if (!rriReservoirEnabled && selectedStation?.type === 'reservoir') {
      setRightSidebarOpen(false);
    }
  }, [rriStationEnabled, rriReservoirEnabled]);

    useEffect(() => {
      // fetch(`${initFewsUrl}/model-output/data_portal/metadata/hii_waterlevel.csv`)
      //   .then(res => res.text())
      //   .then(result => {
      //     const rawData = Papa.parse(result).data.slice(1);
      //     setDatas(rawData);
      //   })
      //   .catch(err => console.error('fetch waterlevel error:', err));

      fetch(`${API}/public/rain_24h`)
        .then(res => res.json())
        .then(result => setDataRainfall24(orderBy(result.data, ['rain_24h'], ['desc']).filter(d => d.rain_24h > 0)));

      fetch(`${API}/public/rain_today`)
        .then(res => res.json())
        .then(result => setDatasRainTodayMarker(orderBy(result.data, ['rainfall_value'], ['desc']).filter(d => d.rainfall_value > 0)));

      fetch(`${API}/public/rain_yesterday`)
        .then(res => res.json())
        .then(result => setDatasRainYesterday(orderBy(result.data, ['rainfall_value'], ['desc']).filter(d => d.rainfall_value > 0)));

      fetch(`${API}/provinces/rain3d`)
        .then(res => res.json())
        .then(result => setDatasRain3day(orderBy(result.data, ['rain_3d'], ['desc']).filter(d => d.rain_3d > 0)));

      fetch(`${API}/provinces/rain7d`)
        .then(res => res.json())
        .then(result => setDatasRain7day(result.data.filter(d => d.rain_7d > 0)));

      fetch(`${API}/provinces/rain15d`)
        .then(res => res.json())
        .then(result => setDatasRain15Day(orderBy(result.data, ['rain_15d'], ['desc']).filter(d => d.rain_15d >= 0.1)));

      fetch(`${API}/public/rain_monthly`)
        .then(res => res.json())
        .then(result => {
          if (!result.data) return;
          const sorted = orderBy(result.data, ['rainfall_value'], ['desc']);
          setDatasRain30Day(sorted.filter(d => d.rainfall_value >= 0.1));
        })
        .catch(err => console.error('rain_monthly error:', err));

      fetch(`${API}/analyst/dam`)
        .then(res => res.json())
        .then(result => {
          const currentDateTime = new Date();
          const last24hrs = new Date().setDate(currentDateTime.getDate() - 2);

          const largeSorted = orderBy(result.data.dam_daily, ['dam_storage_percent'], ['desc']);
          setDatasLargeDam(largeSorted.filter(d => {
            const time = new Date(d.dam_date).getTime();
            return (last24hrs < time && d.agency.id === 12) || [231, 319, 320].includes(d.dam.id);
          }));

          const mediumSorted = orderBy(result.data.dam_medium, [o => o.dam_storage_percent || ''], ['desc']);
          setDatasMediumDam(mediumSorted.filter(d => {
            const time = new Date(d.dam_date).getTime();
            return last24hrs < time || d.dam_date === '1970-01-01';
          }));
        })
        .catch(err => console.error('fetch dam error:', err));

      fetch(`${process.env.REACT_APP_LIVE_HII}/product/latest/rri/metadata/json/rri_station_final_V3.geojson`)
        .then(res => res.json())
        .then(data => setRriStations(data.features.filter(f => f.geometry !== null)))
        .catch(err => console.error('fetch rri station error:', err));

      fetch(`${API}/public/waterlevel_load`)
        .then(res => res.json())
        .then(result => {
          const map = {};
          (result.waterlevel_data?.data ?? []).forEach(item => {
            map[item.station.id] = {
              discharge:       parseFloat(item.discharge),
              situation_level: item.situation_level,
              waterlevel_msl:  parseFloat(item.waterlevel_msl),
              station_name:    item.station.tele_station_name?.th,
              oldcode:         item.station.tele_station_oldcode,
            };
          });
          setWaterlevelMeta(map);
        });

      fetch(`${API}/analyst/dam`)
        .then(res => res.json())
        .then(result => {
          const map = {};
            (result.data?.dam_daily ?? []).forEach(item => {
              map[item.dam.id] = {
                storage_percent: parseFloat(item.dam_storage_percent),
                dam_name:        item.dam.dam_name?.th,
                date:            item.dam_date,
                isMedium: false,
              };
            });
            (result.data?.dam_medium ?? []).forEach(item => {
              map[item.dam.id] = {
                storage_percent: parseFloat(item.dam_storage_percent),
                dam_name:        item.dam.dam_name?.th,
                date:            item.dam_date,
                isMedium: true,
              };
            });
          setDamMeta(map);
        });

    }, []);

    useEffect(() => {
      const runDate = dayjs().format('YYYYMMDD') + '07';
      const DatapathDate = dayjs().subtract(1, 'day').format('YYYYMMDD') + '07';
      const forecastDate = dayjs().add(forecastDay - 1, 'day').format('YYYYMMDD') + '07';
      const url = `${process.env.REACT_APP_LIVE_HII}/product/latest/rri/qr/THA_qr_${DatapathDate}_${forecastDate}.tif`;
      setRriTifUrl(url);
    }, [forecastDay]);

    // useEffect(() => {
    //   if (!rriStations || rriStations.length === 0) return;

    //   const controller = new AbortController();
    //   const signal = controller.signal;
    //   const today = dayjs();
    //   const startDate = today.subtract(7, 'day').format('YYYY-MM-DD');
    //   const endDate = today.format('YYYY-MM-DD HH:mm');

    //   const stationFeatures = rriStations.filter(f => f.properties?.station && f.properties?.id);

    //   const fetchInBatches = async (features, batchSize = 10) => {
    //     for (let i = 0; i < features.length; i += batchSize) {
    //       if (signal.aborted) break;
    //       const batch = features.slice(i, i + batchSize);
    //       await Promise.all(batch.map(async (feature) => {
    //         const { id } = feature.properties;
    //         try {
    //           const res = await fetch(
    //             `${API}/public/waterlevel_graph?station_type=tele_waterlevel&station_id=${id}&start_date=${startDate}&end_date=${endDate}`,
    //             { signal }
    //           );
    //           const data = await res.json();
    //           const rows = data?.data?.graph_data ?? [];
    //           const last = [...rows].reverse().find(r => r.discharge !== null && r.discharge !== undefined);
    //           if (last?.discharge != null) {
    //             setWaterlevelMeta(prev => ({
    //               ...prev,
    //               [id]: { ...prev[id], discharge: parseFloat(last.discharge) },
    //             }));
    //           }
    //         } catch {}
    //       }));
    //     }
    //   };

    //   fetchInBatches(stationFeatures, 10);
    //   return () => controller.abort();

    // }, [rriStations]);

    // useEffect(() => {
    //   if (!rriStations || rriStations.length === 0) return;

    //   const controller = new AbortController();
    //   const signal = controller.signal; 

    //   const stations = rriStations
    //     .filter(f => f.properties?.station || f.properties?.reservoir)
    //     .map(f => f.properties.station || f.properties.reservoir);

    //   const fetchInBatches = async (items, batchSize = 20) => {
    //     const result = {};
    //     const now = new Date(); // ← เพิ่ม

    //     for (let i = 0; i < items.length; i += batchSize) {
    //       if (signal.aborted) break;
    //       const batch = items.slice(i, i + batchSize);
    //       await Promise.all(batch.map(async (station) => {
    //         try {
    //           const url = `${process.env.REACT_APP_LIVE_HII}/product/latest/rri/station/${station}.csv`;
    //           const res = await fetch(url, { signal });
    //           const text = await res.text();
    //           const lines = text.trim().split('\n')
    //             .filter(line => !line.startsWith('datetime') && line.trim() !== '');

    //           let closestQr = null;
    //           let closestDiff = Infinity;

    //           lines.forEach(line => {
    //             const cols = line.split(',');
    //             const dt = new Date(cols[0]);
    //             const qr = parseFloat(cols[2]);
    //             if (isNaN(dt.getTime()) || isNaN(qr)) return;
    //             const diff = now - dt;
    //             if (diff >= 0 && diff < closestDiff) {
    //               closestDiff = diff;
    //               closestQr = qr;
    //             }
    //           });

    //           if (closestQr !== null) result[station] = closestQr;
    //         } catch {}
    //       }));
    //     }
    //     return result;
    //   };

    //   useEffect(() => {
    //     if (!rriStations || rriStations.length === 0) return;

    //     const controller = new AbortController();
    //     const signal = controller.signal;
    //     const today = dayjs();
    //     const startDate = today.subtract(1, 'day').format('YYYY-MM-DD');
    //     const endDate = today.format('YYYY-MM-DD HH:mm');
    //     const thisYear = today.year();

    //     const fetchInBatches = async (features, batchSize = 10) => {
    //       const result = {};

    //       for (let i = 0; i < features.length; i += batchSize) {
    //         if (signal.aborted) break;
    //         const batch = features.slice(i, i + batchSize);

    //         await Promise.all(batch.map(async (feature) => {
    //           const { station, reservoir } = feature.properties;

    //           try {
    //             if (station) {
    //               const stationId = RRI_STATION_META[station]?.station_id;
    //               if (!stationId) return;
    //               const res = await fetch(`${API}/public/waterlevel_graph?station_type=tele_waterlevel&station_id=${stationId}&start_date=${startDate}&end_date=${endDate}`, { signal });
    //               const data = await res.json();
    //               const rows = data?.data?.graph_data ?? [];
    //               const last = [...rows].reverse().find(r => r.discharge !== null);
    //               if (last) result[station] = last.discharge;

    //             } else if (reservoir) {
    //               const meta = RRI_RESERVOIR_META[reservoir];
    //               if (!meta) return;
    //               const url = meta.medium_id
    //                 ? `${API}/analyst/dam_medium_graph?data_type=mediumdam_inflow&medium_id=${meta.medium_id}&year=${thisYear}`
    //                 : `${API}/analyst/dam_yearly_graph?data_type=dam_inflow&dam_id=${meta.dam_id}&year=${thisYear}`;
    //               const res = await fetch(url, { signal });
    //               const data = await res.json();
    //               const rows = data?.data?.graph_data?.[0]?.data ?? [];
    //               const last = [...rows].reverse().find(r => r.value !== null);
    //               if (last) result[reservoir] = last.value;
    //             }
    //           } catch {}
    //         }));
    //       }
    //       return result;
    //     };

    //     fetchInBatches(rriStations, 10).then(result => {
    //       console.log('rriLatestQr from API:', result);
    //       if (!signal.aborted) setRriLatestQr(result);
    //     });

    //     return () => controller.abort();

    //   }, [rriStations]);

    //   fetchInBatches(stations, 20).then(result => {
    //     if (!signal.aborted) setRriLatestQr(result);
    //   });

    //   return () => controller.abort();

    // }, [rriStations]);

    // useEffect(() => {
    //   if (!rriStations || rriStations.length === 0) return;

    //   const controller = new AbortController();
    //   const signal = controller.signal;
    //   const today = dayjs();
    //   const startDate = today.subtract(1, 'day').format('YYYY-MM-DD');
    //   const endDate = today.format('YYYY-MM-DD HH:mm');
    //   const thisYear = today.year();

    //   const fetchInBatches = async (features, batchSize = 10) => {
    //     const result = {};

    //     for (let i = 0; i < features.length; i += batchSize) {
    //       if (signal.aborted) break;
    //       const batch = features.slice(i, i + batchSize);

    //       await Promise.all(batch.map(async (feature) => {
    //         const { station, reservoir } = feature.properties;

    //         try {
    //           if (station) {
    //             const stationId = RRI_STATION_META[station]?.station_id;
    //             if (!stationId) return;
    //             const res = await fetch(`${API}/public/waterlevel_graph?station_type=tele_waterlevel&station_id=${stationId}&start_date=${startDate}&end_date=${endDate}`, { signal });
    //             const data = await res.json();
    //             const rows = data?.data?.graph_data ?? [];
    //             const last = [...rows].reverse().find(r => r.discharge !== null);
    //             if (last) result[station] = last.discharge;

    //           } else if (reservoir) {
    //             const meta = RRI_RESERVOIR_META[reservoir];
    //             if (!meta) return;
    //             const url = meta.medium_id
    //               ? `${API}/analyst/dam_medium_graph?data_type=mediumdam_inflow&medium_id=${meta.medium_id}&year=${thisYear}`
    //               : `${API}/analyst/dam_yearly_graph?data_type=dam_inflow&dam_id=${meta.dam_id}&year=${thisYear}`;
    //             const res = await fetch(url, { signal });
    //             const data = await res.json();
    //             const rows = data?.data?.graph_data?.[0]?.data ?? [];
    //             const last = [...rows].reverse().find(r => r.value !== null);
    //             if (last) result[reservoir] = last.value;
    //           }
    //         } catch {}
    //       }));
    //     }
    //     return result;
    //   };

    //   fetchInBatches(rriStations, 10).then(result => {
    //     if (!signal.aborted) setRriLatestQr(result);
    //   });

    //   return () => controller.abort();

    // }, [rriStations]);

    useEffect(() => {
      fetch(`${process.env.REACT_APP_LIVE_HII}/product/latest/rri/metadata/csv/rri_station_coordinate_qr.csv`)
        .then(res => res.text())
        .then(text => {
          const lines = text.trim().split('\n').slice(1); // skip header
          const map = {};
          lines.forEach(line => {
            const [order, station, lat, lon, lowest, alarm, warning, critical] = line.split(',');
            if (station) {
              map[station.trim()] = {
                alarm:    parseFloat(alarm)    || null,
                warning:  parseFloat(warning)  || null,
                critical: parseFloat(critical) || null,
              };
            }
          });
          setRriThresholds(map);
        })
        .catch(err => console.error('fetch threshold error:', err));
    }, []);

    const getStationStatus = (feature) => {
      const { station, reservoir, id } = feature.properties ?? {};
      const name = station || reservoir;
      const qr = station ? waterlevelMeta[id]?.discharge : rriLatestQr[reservoir];
      const th = rriThresholds[name];
      if (qr == null || isNaN(qr) || !th) return 'normal';
      if (th.critical != null && qr >= th.critical) return 'critical';
      if (th.alarm    != null && qr >= th.alarm)    return 'alarm';
      return 'normal';
    };

    const isMarkerDataReady =
      Object.keys(waterlevelMeta).length > 0 &&
      Object.keys(rriThresholds).length > 0 &&
      Object.keys(damMeta).length > 0;

    const visibleRriStations = React.useMemo(() => {
      if (statusFilter === 0) return rriStations;
      return rriStations.filter(f => {
        const status = getStationStatus(f);
        if (statusFilter === 1) return status === 'critical';
        if (statusFilter === 2) return status === 'alarm';
        return true;
      });
    }, [rriStations, rriLatestQr, waterlevelMeta, rriThresholds, statusFilter]);

  return (
    <Box>
      {/* Header */}
      <Box display="flex" alignItems="center" mb={2}>
        <Box
          display="flex"
          className={classes.shapeCircle}
          alignItems="center"
          justifyContent="center"
        >
          <OpacityIcon style={{ color: '#fff' }} />
        </Box>
        <Box p={1}>
          <Typography variant="h6" className={classes.titlePage}>
            {t('ระบบคาดการณ์น้ำท่าด้วยแบบจำลอง RRI')}
          </Typography>
        </Box>
      </Box>

      {/* Sidebar + Map */}
        <Box mt={2} mb={2} display="flex"
          style={{
            width: '100%',
            height: 'calc(100vh - 150px)',
            overflow: 'hidden',
          }}
        >
        <RRISidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          mainRiver={mainRiver} 
          setMainRiver={setMainRiver}
          basin={basin} 
          setBasin={setBasin}
          waterLevel={waterLevel}
          setWaterLevel={setWaterLevel}
          rainfallEnabled={rainfallEnabled}
          setRainfallEnabled={setRainfallEnabled}
          forecastDay={forecastDay}
          setForecastDay={setForecastDay}
          largeDamEnabled={largeDamEnabled}
          setLargeDamEnabled={setLargeDamEnabled}
          mediumDamEnabled={mediumDamEnabled}
          setMediumDamEnabled={setMediumDamEnabled}
          rriStationEnabled={rriStationEnabled}
          setRriStationEnabled={setRriStationEnabled}
          rriReservoirEnabled={rriReservoirEnabled}
          setRriReservoirEnabled={setRriReservoirEnabled}
          rriStations={rriStations}
          onStationSelect={(lat, lng) => {
            if (mapInstance) {
              mapInstance.setView([lat, lng], 12);
            }
          }}
          rriTifEnabled={rriTifEnabled}
          setRriTifEnabled={setRriTifEnabled}
          rriLatestQr={rriLatestQr}
          rriThresholds={rriThresholds}
          waterlevelMeta={waterlevelMeta}
          onStatusChange={setStatusFilter}
        />

        <Box
          flex={1}
          style={{
            position: 'relative',
            overflow: 'hidden',
            height: '100%',
            zIndex: 0, 
          }}
        >
          <RRIMap
            location={[13.0, 101.0]}
            zoom={6}
            handleSetMap={handleSetMap}
            sidebarOpen={sidebarOpen}
            onOpenSidebar={() => setSidebarOpen(true)}
            mainRiver={mainRiver}
            layers={{ basin }}
            datas={datas}
            waterLevel={waterLevel}
            markers={[]}
            handleModalOpen={handleModalOpen}
            rainfallEnabled={rainfallEnabled}
            rainfallType={forecastDayToType[forecastDay]}
            datasRainTodayMarker={datasRainTodayMarker}
            datasRainYesterday={datasRainYesterday}
            dataRainfall24={dataRainfall24}
            datasRain3day={datasRain3day}
            datasRain7day={datasRain7day}
            datasRain15Day={datasRain15Day}
            datasLargeDam={datasLargeDam}
            datasMediumDam={datasMediumDam}
            largeDamEnabled={largeDamEnabled}
            mediumDamEnabled={mediumDamEnabled}
            rriStationEnabled={rriStationEnabled}
            rriTifUrl={rriTifUrl}
            rriReservoirEnabled={rriReservoirEnabled}
            onMarkerClick={handleMarkerClick}
            rriLatestQr={rriLatestQr}
            rriTifEnabled={rriTifEnabled}
            rriStations={isMarkerDataReady ? visibleRriStations : []}
            datasRain30Day={datasRain30Day}
            waterlevelMeta={waterlevelMeta}
            rriThresholds={rriThresholds} 
            damMeta={damMeta}
          />
        </Box>
          <RRIRightSidebar
            open={rightSidebarOpen}
            onClose={() => setRightSidebarOpen(false)}
            selected={selectedStation}
            waterlevelMeta={waterlevelMeta}
            damMeta={damMeta}
          />
      </Box>

      <Dialog open={modalOpen} onClose={handleModalClose} maxWidth="md" fullWidth container={() => document.fullscreenElement || document.body} disableEnforceFocus sx={{ zIndex: 9999999 }}>
        <DialogTitle>
          {modalContent.header}
          <IconButton onClick={handleModalClose} style={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {modalContent.content}
        </DialogContent>
      </Dialog>
    </Box>
  );
}